export default __webpack_public_path__ + "static/online-shopper-87b253d299888f82e1894ab4296654f9.jpg";